import { Link } from "react-router-dom";
import LegalPage, { Section, useCompany } from "@/components/public/LegalPage";

export default function Terms() {
  const co = useCompany();
  return (
    <LegalPage title="Terms & Conditions" testid="terms-page">
      <p className="text-slate-600">
        These terms apply to services provided by {co.name}, company number {co.number}, registered office {co.office}. Contact: {co.email}, {co.phone}.
      </p>
      <Section title="Quotes">
        <p>Quotes are free, based on the information and photos you provide, and valid for 30 days. If the job turns out to be materially different on the day, we will agree any change in price with you before continuing.</p>
      </Section>
      <Section title="Your right to cancel">
        <p>If you agree a job with us away from our premises (for example at your home, by phone or online), you have 14 days to cancel without giving a reason under the Consumer Contracts Regulations 2013.</p>
        <p>If you ask us to start work within those 14 days and then cancel, you may have to pay for the work already done. Once work is fully completed at your request, the right to cancel no longer applies.</p>
      </Section>
      <Section title="Rescheduling">
        <p>Outdoor work depends on the weather. We may need to rearrange visits for safety or quality reasons and will let you know as early as possible. Please give us at least 24 hours' notice if you need to rearrange.</p>
      </Section>
      <Section title="Access and your property">
        <p>Please make sure we have safe access, an outside water supply where needed, and that vehicles, pets and fragile items are moved away from the work area. Please tell us about any known damage, loose paving or weak surfaces before we start.</p>
      </Section>
      <Section title="Payment">
        <p>Payment is due by the date shown on your invoice. We are not currently VAT registered, so no VAT is charged.</p>
      </Section>
      <Section title="Our responsibility to you">
        <p>We carry out all work with reasonable care and skill. If something isn't right, tell us within 7 days and we will come back to put it right. We are not responsible for pre-existing defects that cleaning reveals, or for losses we could not reasonably foresee. Nothing in these terms limits your statutory rights.</p>
      </Section>
      <Section title="Complaints">
        <p>If you are unhappy, contact us at {co.email}. We aim to reply within 5 working days and resolve complaints within 14 days.</p>
      </Section>
      <Section title="Your data">
        <p>See our <Link to="/privacy" className="text-green-700 underline">Privacy Policy</Link>. These terms are governed by the law of England and Wales.</p>
      </Section>
    </LegalPage>
  );
}
